import React, { CSSProperties } from "react";
import { Form, Row } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";

import type { OtpRegisterUIProps } from "./OtpRegister.types";

import { SubHeaderLabel, HeaderLabel, GreenLabel, InvalidText } from "../Labels.tsx";
import { ActionButton } from "../Buttons.tsx";
import { OTPInput } from "../Inputs.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

const otpContainerStyle: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
  margin: "0 0 1rem 0",
};

const OtpRegisterUI: React.FC<OtpRegisterUIProps> = ({
  otp,
  validated,
  handleChange,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const { onResendCode, loadingComponent, email, isLoading } = useLoginContext();

  if (isLoading) return loadingComponent;

  return (
    <Row style={{ maxWidth: 400 }} className="mx-auto">
      <HeaderLabel>{t("otpRegister.title")}</HeaderLabel>

      <SubHeaderLabel>{t("otpRegister.subtitle", { email })}</SubHeaderLabel>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group controlId="otpInput">
          <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            renderInput={(props) => (
              <OTPInput {...props} required hasError={validated && otp.length < 6} />
            )}
            containerStyle={otpContainerStyle}
          />

          {validated && otp.length < 6 && <InvalidText>{t("otpRegister.invalidCode")}</InvalidText>}
        </Form.Group>

        <GreenLabel textAlign="right" onClick={onResendCode}>
          {t("otpRegister.resendCode")}
        </GreenLabel>

        <ActionButton type="submit">{t("otpRegister.confirm")}</ActionButton>
      </Form>
    </Row>
  );
};

export default OtpRegisterUI;
